import Layout from "@components/Layout";
import HomeHotel10Container from "@containers/HomeHotel10Container";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import WrapperProvider from "@providers/WrapperProvider";
import { getServer } from "@translations/next";
import _ from "lodash";
import StrapiService from "@services/StrapiService";
import RoomService from "@services/RoomService";
import FooterService from "@services/FooterService";

export default function View(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <HomeHotel10Container />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}

export const getServerSideProps = getServer(async ({ params }) => {
  const locale: any = _.get(params, "locale", "en");
  StrapiService.set("id", "hotel65-home-page");
  const res = await StrapiService.find({ populate: "deep", locale });
  const resRoom = await RoomService.find({
    populate: ["thumbnail", "images", "thumbnailBackground"],
    locale,
  });

  // Get Stay Connected
  StrapiService.set("id", "hotel65-stay-connected");
  const resInspired = await StrapiService.find({
    populate: "deep",
    locale,
  });
  const footerData = await FooterService.fetchByHotel("amanaki-boutique-saigon", locale);

  return {
    hotel: "amanaki-boutique-saigon",
    pageData: {
      ..._.get(res, "data", {}),
      stayConnected: _.get(resInspired, "data", {}),
    },
    rooms: _.get(resRoom, "data", []),
    footerData,
  };
});
